export default "__VITE_ASSET__hLlYkWi___"